<template>
    <component :is="tag" :class="tagClass">
        {{ textComputed }}
        <template v-if="isMore">
            <a href="javascript:void(0)" @click="onClickMore">
                <small>{{ $t("button.show") }}...</small>
            </a>
        </template>
        <template v-if="isHide">
            <a href="javascript:void(0)" @click="onClickHide">
                <small>{{ $t("button.hide") }}...</small>
            </a>
        </template>
    </component>
</template>

<script>
import { computed, defineComponent, reactive } from "vue";

export default defineComponent({
    components: {},
    props: {
        tag: { default: "div" },
        tagClass: {},
        text: {},
        end: { default: 20 },
    },
    setup(props) {
        const data = reactive({ end: props.end });
        const textComputed = computed(() => props.text?.substring(0, data.end));
        const isMore = computed(() => props.text && data.end <= props.end && data.end < props.text.length);
        const isHide = computed(() => props.text && data.end > props.end);
        const onClickMore = () => (data.end = props.text.length);
        const onClickHide = () => (data.end = props.end);
        return { data, textComputed, isMore, isHide, onClickMore, onClickHide };
    },
});
</script>
